import { render } from "./ResetSenhaView.vue?vue&type=template&id=02bb83d8"
import script from "./ResetSenhaView.vue?vue&type=script&lang=js"
export * from "./ResetSenhaView.vue?vue&type=script&lang=js"

import "./ResetSenhaView.vue?vue&type=style&index=0&id=02bb83d8&lang=css"

import exportComponent from "C:\\SGCAD25\\Domus Fiança\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__